<div id="top-header">
    <div class="container-fluid px-xl-3 px-xxl-5">
        <div class="row align-items-center">
            <div class="col-10 col-lg-4">
                <!-- Desktop: helpline + email -->
                <ul class="nav justify-content-start top-left-info d-none d-lg-flex">
                    <li class="nav-item">
                        <a class="nav-link" href="tel:9717594526"><i class="fa-solid fa-phone"></i> Helpline: -
                            +91 9717594526</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="mailto:ideal_institute2@rediffmail.com"><i
                                class="fa-solid fa-envelope"></i> ideal_institute2@rediffmail.com</a>
                    </li>
                </ul>
                <!-- Mobile: helpline + email -->
                <ul class="nav top-left-info top-left-info-mobile d-flex d-lg-none">
                    <li class="nav-item">
                        <a class="nav-link" href="tel:9717594526"><i class="fa-solid fa-phone"></i> 9717594526</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="mailto:ideal_institute2@rediffmail.com"><i
                                class="fa-solid fa-envelope"></i> ideal_institute2@rediffmail.com</a>
                    </li>
                </ul>
            </div>
            <div class="col-2 col-lg-8">
                <!-- Mobile hamburger toggle - only visible on mobile/tablet -->
                <div class="d-lg-none text-end">
                    <button class="top-header-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#topHeaderCollapse" aria-controls="topHeaderCollapse" aria-expanded="false"
                        aria-label="Toggle top navigation">
                        <i class="fa-solid fa-bars"></i>
                    </button>
                </div>
                <!-- Desktop menu (always visible on lg+) -->
                <div class="d-none d-lg-flex justify-content-end">
                    <ul class="nav flex-row">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Faculty
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><a class="dropdown-item" routerLink="/faculty/management">Department of Management &
                                        IT</a></li>
                                <li><a class="dropdown-item" routerLink="/faculty/law">School of Law</a></li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" routerLink="/alumni">Alumni</a></li>
                        <li class="nav-item"><a class="nav-link" routerLink="/publications">Publications</a></li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="navbarDropdownMgmtDsk" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Admissions 2026-27
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMgmtDsk">
                                <li><a class="dropdown-item" routerLink="/mgmt/admission24">Vacant Seats Admission 2026-27</a></li>
                                <li><a class="dropdown-item" routerLink="/mgmt/admission26">MGMT. Quota Admission 2026-27</a></li>
                                <!--<li><a class="dropdown-item" routerLink="/mgmt/admission25">MGMT. Quota Admission 2025-26</a></li>-->
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="navbarDropdownMgmtDsk" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Reappear Fee 2026-27
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMgmtDsk">
                                <li><a class="nav-link" href="https://rzp.io/rzp/reappear-fee" target="_blank">BBA & BCA</a></li>
                                <li><a class="nav-link" href="https://rzp.io/rzp/reappear_fee" target="_blank">BA LL.B</a></li>
                            </ul>
                        </li>
                        <!-- <li class="nav-item"><a class="nav-link" href="https://odp.page.link/app" target="_blank">Online
                                Payment</a></li> -->
                        <li class="nav-item"><a class="nav-link" href="https://odp.page.link/app" target="_blank">Login
                                / Payment</a></li>
                        <li class="nav-item"><a class="nav-link"
                                href="https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Frli%3Dy7f7r5kwonr0%26rld%3D1&flowEntry=AddSession&flowName=GlifWebSignIn&hd=idealinstitute.edu.in&sacu=1&service=mail&dsh=S-216056736%3A1774702078384927"
                                target="_blank">WEBMAIL</a></li>
                        <li class="nav-item"><a class="nav-link" routerLink="/contact-us">Contact Us</a></li>
                    </ul>
                </div>
                <!-- Mobile collapse menu -->
                <div class="collapse" id="topHeaderCollapse">
                    <ul class="nav flex-column top-mobile-menu">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="topNavFacultyMob" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Faculty
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="topNavFacultyMob">
                                <li><a class="dropdown-item" routerLink="/faculty/management">Department of Management &
                                        IT</a></li>
                                <li><a class="dropdown-item" routerLink="/faculty/law">School of Law</a></li>
                            </ul>
                        </li>
                        <li class="nav-item"><a class="nav-link" routerLink="/alumni">Alumni</a></li>
                        <li class="nav-item"><a class="nav-link" routerLink="/publications">Publications</a></li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="topNavMgmtMob" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Admissions 2026-27
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="topNavMgmtMob">
                                <li><a class="dropdown-item" routerLink="/mgmt/admission24">Vacant Seats Admission 2026-27</a></li>
                                <li><a class="dropdown-item" routerLink="/mgmt/admission26">MGMT. Quota Admission 2026-27</a></li>
                                <!--<li><a class="dropdown-item" routerLink="/mgmt/admission25">MGMT. Quota Admission 2025-26</a></li>-->
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" id="navbarDropdownMgmtDsk" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                                Reappear Fee 2026-27
                            </a>
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMgmtDsk">
                                <li><a class="nav-link" href="https://rzp.io/rzp/reappear-fee" target="_blank">BBA & BCA</a></li>
                                <li><a class="nav-link" href="https://rzp.io/rzp/reappear_fee" target="_blank">BA LL.B</a></li>
                            </ul>
                        </li>
                        <!-- <li class="nav-item"><a class="nav-link" href="https://odp.page.link/app" target="_blank">Online Payment</a></li> -->
                        <li class="nav-item"><a class="nav-link" href="https://odp.page.link/app" target="_blank">Login
                                / Payment</a></li>
                        <li class="nav-item"><a class="nav-link"
                                href="https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Frli%3Dy7f7r5kwonr0%26rld%3D1&flowEntry=AddSession&flowName=GlifWebSignIn&hd=idealinstitute.edu.in&sacu=1&service=mail&dsh=S-216056736%3A1774702078384927"
                                target="_blank">WEBMAIL</a></li>
                        <li class="nav-item"><a class="nav-link" routerLink="/contact-us">Contact Us</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="middle-header" class="d-none d-lg-block">
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid px-xl-3 px-xxl-5">
            <a class="navbar-brand py-0" routerLink="/"><img src="/assets/img/logo/4.png" alt="Logo"
                    class="img-fluid"></a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#menu"
                aria-controls="menu" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="menu">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" routerLink="/">Home</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            About Us
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/about/vision-mission">Vision & Mission</a></li>
                            <li><a class="dropdown-item" routerLink="/about/quality-policy">Quality Policy</a></li>
                            <li><a class="dropdown-item" routerLink="/about/affiliation">Affiliation</a></li>
                            <li><a class="dropdown-item" routerLink="/about/recognition">Recognition & Approvals</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/about/messages">Messages</a></li>
                            <li><a class="dropdown-item" routerLink="/about/governing">Governing Body</a></li>
                            <li><a class="dropdown-item" routerLink="/about/advisory">Advisory Board</a></li>
                            <li><a class="dropdown-item" routerLink="/about/committee">Committees</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Infrastructure
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <!-- <li><a class="dropdown-item" routerLink="/infrastructure/iqac-room">IQAC Room</a></li> -->
                            <li><a class="dropdown-item" routerLink="/infrastructure/smart-class">SMART CLASS ROOMS</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/computer-lab">Computer Lab</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/library">Library</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/moot-court">Moot Court Room</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/auditorium">AUDITORIUM</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/seminar">seminar Hall</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/conference">Conference Room</a>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Academics
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <!-- <a class="dropdown-item" routerLink="/academics/departments"></a> -->
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                                Resources</h6>
                                    <a class="dropdown-item" routerLink="/academics/procedure">Admission Procedure</a>
                                    <!-- <a class="dropdown-item" routerLink="/academics/courses">Courses</a> -->
                                    <a class="dropdown-item" routerLink="/academics/courses-outcomes">Course
                                        Outcomes</a>
                                    <a class="dropdown-item" routerLink="/academics/fee-structure">Fee Structure</a>
                                    <a class="dropdown-item" routerLink="/academics/academic-calender">Academic
                                        Calender</a>
                                    <!-- <a class="dropdown-item" routerLink="/academics/syllabus">Syllabus</a> -->
                                </div>
                                <div class="col-12 col-lg-8">
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                                Departments</h6>
                                            <a class="dropdown-item" routerLink="/departements/management">Department of
                                                Management</a>
                                            <a class="dropdown-item" routerLink="/departements/it">Department of
                                                I.T.</a>
                                            <a class="dropdown-item" routerLink="/departements/law">School of Law</a>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                                Programmes</h6>
                                            <a class="dropdown-item" routerLink="/courses/bba">BBA (1st Shift
                                                & 2nd Shift)</a>
                                            <a class="dropdown-item" routerLink="/courses/bca">BCA (1st Shift
                                                & 2nd Shift)</a>
                                            <a class="dropdown-item" routerLink="/courses/ba">BA LL.B (Hons.)</a>
                                            <a class="dropdown-item" routerLink="/courses/llm"> LL.M (Corp. Law) & LL.M
                                                (IPR)</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Facilities
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/facilities/common-rooms">Common Rooms</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/sports">Sports</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/medical">Medical Care</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/counselling">Student Counseling</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/facilities/cafetaria">Cafetaria</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Life &#64; IIMT
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                        EXPERIENTIAL LEARNING</h6>
                                    <a class="dropdown-item"
                                        routerLink="/life-iimt/conference">Conferences/FDPs/Debates</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/club">Clubs & Societies</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/field">Industrial/Educational
                                        Visits</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/excursions">Excursions</a>
                                </div>
                                <div class="col-12 col-lg-8">
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                                BEYOND ACADEMICS</h6>
                                            <a class="dropdown-item" routerLink="/activities/management">Department of
                                                Management</a>
                                            <a class="dropdown-item" routerLink="/activities/it">Department of IT</a>
                                            <a class="dropdown-item" routerLink="/activities/law">School of Law</a>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                                STUDENTS’ ACHIEVEMENTS</h6>
                                            <a class="dropdown-item" routerLink="/achievement/gold-medal">Gold
                                                Medalists</a>
                                            <a class="dropdown-item" routerLink="/achievement/fame">Hall of Fame</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Placements
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/placements/training2526">Training & Placement
                                    2025-26</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training2425">Training & Placement
                                    2024-25</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training1">Training & Placement
                                    2023-24</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training2">Training & Placement
                                    2022-23</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training3">Para Legal Volunteer
                                    Training</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            IQAC
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/iqac/iimt-iqac">IIMT IQAC</a></li>
                            <li><a class="dropdown-item" routerLink="/iqac/members">Members</a></li>
                            <li><a class="dropdown-item" routerLink="/iqac/mom">Minutes of Meeting</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            NAAC
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                        NAAC ACCREDITATION CYCLE –3</h6>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-three/documents-aqar-twenty-four">DOCUMENTS AQAR
                                        2023–24</a>
                                </div>

                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                        NAAC ACCREDITATION CYCLE –2</h6>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-two/aqar/aqar">AQAR</a>
                                    <a class="dropdown-item" routerLink="/">DOCUMENTS AQAR
                                        2018–19</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/criterian-4.pdf"
                                        target="_blank">( CRITERION 4
                                        )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/criterion-7.pdf"
                                        target="_blank">( CRITERION 7
                                        )</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-one">DOCUMENTS AQAR
                                        2020–21</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-two">DOCUMENTS AQAR
                                        2021–22</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-three">DOCUMENTS AQAR
                                        2022–23</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/ideal-institute-of-management-and-technology-iiqa.pdf"
                                        target="_blank">IIQA</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-two/ssr-documents">SSR
                                        DOCUMENTS</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/ssr-2024-2nd-cycle-of-accredition.pdf"
                                        target="_blank">SSR
                                        CYCLE 2</a>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">
                                        NAAC ACCREDITATION CYCLE –1
                                    </h6>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Criterian-4.pdf"
                                        target="_blank">CRITERION 4</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Criterian-7.pdf"
                                        target="_blank">CRITERION 7</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/SSR-Cycle-1.pdf"
                                        target="_blank">SSR CYCLE–1</a>
                                    <a class="dropdown-item" routerLink="">TEMPLATES</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-one/main-one">( MAIN )</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-one/extended">( EXTENDED )</a>
                                    <a class="dropdown-item" routerLink="">NAAC ACCREDITATION OUTCOME</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/NAAC-Certificate.pdf"
                                        target="_blank">( NAAC CERTIFICATE )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Peer-Team-Metric-Wise-Score-Sheet.pdf"
                                        target="_blank">( PEER TEAM METRIC WISE SCORE <br> SHEET )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Graphical-Representation-based-on-QnM-&-QlM.pdf"
                                        target="_blank">( GRAPHICAL REPRESENTATION <br> BASED ON )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Institutional_Grade_Sheet.pdf"
                                        target="_blank">( INSTITUTIONAL GRADE SHEET )</a>
                                </div>
                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-expanded="false"
                            (click)="$event.preventDefault()">
                            Initiatives
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown" style="right: 0;">
                            <li><a class="dropdown-item" routerLink="/initiatives/feedback">Feedback Analysis
                                    and Action Taken</a></li>
                            <li><a class="dropdown-item" routerLink="/initiatives/legal">Legal Aid Clinic</a></li>
                            <li><a class="dropdown-item" routerLink="/initiatives/ptm">Parent Teacher
                                    Meeting</a></li>
                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu">Mentor Mentee</h6>
                            <li><a class="dropdown-item" routerLink="/mentor/programme">Mentor Mentee Programme</a></li>
                            <li><a class="dropdown-item" routerLink="/mentor/notice">Mentor Mentee Notice</a></li>
                        </ul>
                    </li>



                </ul>
            </div>
        </div>
    </nav>
</div>
<div id="middle-header" class="d-block d-lg-none">
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid px-xl-3 px-xxl-5">
            <a class="navbar-brand py-0" routerLink="/"><img src="/assets/img/logo/4.png" alt="Logo"
                    class="img-fluid"></a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#menu-mobile"
                aria-controls="menu-mobile" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="menu-mobile">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link active" aria-current="page" routerLink="/">Home</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            About Us
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/about/vision-mission">Vision & Mission</a></li>
                            <li><a class="dropdown-item" routerLink="/about/quality-policy">Quality Policy</a></li>
                            <li><a class="dropdown-item" routerLink="/about/affiliation">Affiliation</a></li>
                            <li><a class="dropdown-item" routerLink="/about/recognition">Recognition & Approvals</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/about/messages">Messages</a></li>
                            <li><a class="dropdown-item" routerLink="/about/governing">Governing Body</a></li>
                            <li><a class="dropdown-item" routerLink="/about/advisory">Advisory Board</a></li>
                            <li><a class="dropdown-item" routerLink="/about/committee">Committees</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Infrastructure
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <!-- <li><a class="dropdown-item" routerLink="/infrastructure/iqac-room">IQAC Room</a></li> -->
                            <li><a class="dropdown-item" routerLink="/infrastructure/smart-class">SMART CLASS ROOMS</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/computer-lab">Computer Lab</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/library">Library</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/moot-court">Moot Court Room</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/auditorium">AUDITORIUM</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/seminar">seminar Hall</a></li>
                            <li><a class="dropdown-item" routerLink="/infrastructure/conference">Conference Room</a>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Academics
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <!-- <a class="dropdown-item" routerLink="/academics/departments"></a> -->
                                    <h6 class="dropdown-header" data-toggle="collapse"
                                                data-target="#menu-mobile">
                                                Resources</h6>
                                    <a class="dropdown-item" routerLink="/academics/procedure">Admission Procedure</a>
                                    <!-- <a class="dropdown-item" routerLink="/academics/courses">Courses</a> -->
                                    <a class="dropdown-item" routerLink="/academics/courses-outcomes">Course
                                        Outcomes</a>
                                    <a class="dropdown-item" routerLink="/academics/fee-structure">Fee Structure</a>
                                    <a class="dropdown-item" routerLink="/academics/academic-calender">Academic
                                        Calender</a>
                                    <!-- <a class="dropdown-item" routerLink="/academics/syllabus">Syllabus</a> -->
                                </div>
                                <div class="col-12 col-lg-8">
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse"
                                                data-target="#menu-mobile">
                                                Departments</h6>
                                            <a class="dropdown-item" routerLink="/departements/management">Department of
                                                Management</a>
                                            <a class="dropdown-item" routerLink="/departements/it">Department of
                                                I.T.</a>
                                            <a class="dropdown-item" routerLink="/departements/law">School of Law</a>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse"
                                                data-target="#menu-mobile">
                                                Programmes</h6>
                                            <a class="dropdown-item" routerLink="/courses/bba">BBA (1st Shift & 2nd
                                                Shift)</a>
                                            <a class="dropdown-item" routerLink="/courses/bca">BCA (1st Shift & 2nd
                                                Shift)</a>
                                            <a class="dropdown-item" routerLink="/courses/ba">BA LL.B (Hons.)</a>
                                            <a class="dropdown-item" routerLink="/courses/llm"> LL.M (Corp. Law) & LL.M
                                                (IPR)</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Facilities
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/facilities/common-rooms">Common Rooms</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/sports">Sports</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/medical">Medical Care</a></li>
                            <li><a class="dropdown-item" routerLink="/facilities/counselling">Student Counseling</a>
                            </li>
                            <li><a class="dropdown-item" routerLink="/facilities/cafetaria">Cafetaria</a></li>
                        </ul>
                    </li>


                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Life &#64; IIMT
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu-mobile">
                                        EXPERIENTIAL LEARNING</h6>
                                    <a class="dropdown-item"
                                        routerLink="/life-iimt/conference">Conferences/FDPs/Debates</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/club">Clubs & Societies</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/field">Industrial/Educational
                                        Visits</a>
                                    <a class="dropdown-item" routerLink="/life-iimt/excursions">Excursions</a>
                                </div>
                                <div class="col-12 col-lg-8">
                                    <div class="row">
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse"
                                                data-target="#menu-mobile">
                                                BEYOND ACADEMICS</h6>
                                            <a class="dropdown-item" routerLink="/activities/management">Department of
                                                Management</a>
                                            <a class="dropdown-item" routerLink="/activities/it">Department of IT</a>
                                            <a class="dropdown-item" routerLink="/activities/law">School of Law</a>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <h6 class="dropdown-header" data-toggle="collapse"
                                                data-target="#menu-mobile">
                                                STUDENTS’ ACHIEVEMENTS</h6>
                                            <a class="dropdown-item" routerLink="/achievement/gold-medal">Gold
                                                Medalists</a>
                                            <a class="dropdown-item" routerLink="/achievement/fame">Hall of Fame</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Placements
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/placements/training2526">Training & Placement
                                    2025-26</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training2425">Training & Placement
                                    2024-25</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training1">Training & Placement
                                    2023-24</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training2">Training & Placement
                                    2022-23</a></li>
                            <li><a class="dropdown-item" routerLink="/placements/training3">Para Legal Volunteer
                                    Training</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            IQAC
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" routerLink="/iqac/iimt-iqac">IIMT IQAC</a></li>
                            <li><a class="dropdown-item" routerLink="/iqac/members">Members</a></li>
                            <li><a class="dropdown-item" routerLink="/iqac/mom">Minutes of Meeting</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown bigDropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            NAAC
                        </a>
                        <ul class="dropdown-menu bigDropdownMenu" aria-labelledby="navbarDropdown">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu-mobile">
                                        NAAC ACCREDITATION CYCLE –3</h6>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-three/documents-aqar-twenty-four">DOCUMENTS AQAR
                                        2023–24</a>
                                </div>

                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu-mobile">
                                        NAAC ACCREDITATION CYCLE –2</h6>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-two/aqar/aqar">AQAR</a>
                                    <a class="dropdown-item" routerLink="/">DOCUMENTS AQAR
                                        2018–19</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/criterian-4.pdf"
                                        target="_blank">( CRITERION 4
                                        )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/criterion-7.pdf"
                                        target="_blank">( CRITERION 7
                                        )</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-one">DOCUMENTS AQAR
                                        2020–21</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-two">DOCUMENTS AQAR
                                        2021–22</a>
                                    <a class="dropdown-item"
                                        routerLink="/naac/naac-cycle-two/documents-aqar-twenty-three">DOCUMENTS AQAR
                                        2022–23</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/ideal-institute-of-management-and-technology-iiqa.pdf"
                                        target="_blank">IIQA</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-two/ssr-documents">SSR
                                        DOCUMENTS</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-2/ssr-2024-2nd-cycle-of-accredition.pdf"
                                        target="_blank">SSR
                                        CYCLE 2</a>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu-mobile">
                                        NAAC ACCREDITATION CYCLE –1
                                    </h6>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Criterian-4.pdf"
                                        target="_blank">CRITERION 4</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Criterian-7.pdf"
                                        target="_blank">CRITERION 7</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/SSR-Cycle-1.pdf"
                                        target="_blank">SSR CYCLE–1</a>
                                    <a class="dropdown-item" routerLink="">TEMPLATES</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-one/main-one">( MAIN )</a>
                                    <a class="dropdown-item" routerLink="/naac/naac-cycle-one/extended">( EXTENDED )</a>
                                    <a class="dropdown-item" routerLink="">NAAC ACCREDITATION OUTCOME</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/NAAC-Certificate.pdf"
                                        target="_blank">( NAAC CERTIFICATE )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Peer-Team-Metric-Wise-Score-Sheet.pdf"
                                        target="_blank">( PEER TEAM METRIC WISE SCORE <br> SHEET )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Graphical-Representation-based-on-QnM-&-QlM.pdf"
                                        target="_blank">( GRAPHICAL REPRESENTATION <br> BASED ON )</a>
                                    <a class="dropdown-item"
                                        href="https://dhfx94npggt9l.cloudfront.net/files/naac-accreditation-cycle-1/Institutional_Grade_Sheet.pdf"
                                        target="_blank">( INSTITUTIONAL GRADE SHEET )</a>
                                </div>
                            </div>
                        </ul>
                    </li>

                    <!--<li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdownMgmtMob" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            MGMT. Quota Admission
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdownMgmtMob">
                            <li><a class="dropdown-item" routerLink="/mgmt/admission26">Admission 2026-27</a></li>
                            <li><a class="dropdown-item" routerLink="/mgmt/admission25">Admission 2025-26</a></li>
                            <li><a class="dropdown-item" routerLink="/mgmt/admission24">Admission 2024-25</a></li>
                        </ul>
                    </li>-->

                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" data-bs-toggle="dropdown"
                            aria-expanded="false" (click)="$event.preventDefault()">
                            Initiatives
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown" style="right: 0;">
                            <li><a class="dropdown-item" routerLink="/initiatives/feedback">Feedback Analysis
                                    and Action Taken</a></li>
                            <li><a class="dropdown-item" routerLink="/initiatives/legal">Legal Aid Clinic</a></li>
                            <li><a class="dropdown-item" routerLink="/initiatives/ptm">Parent Teacher
                                    Meeting</a></li>
                            <h6 class="dropdown-header" data-toggle="collapse" data-target="#menu-mobile">Mentor Mentee
                            </h6>
                            <li><a class="dropdown-item" routerLink="/mentor/programme">Mentor Mentee Programme</a></li>
                            <li><a class="dropdown-item" routerLink="/mentor/notice">Mentor Mentee Notice</a></li>
                        </ul>
                    </li>
                    <!--<li class="nav-item">
                        <a class="nav-link" routerLink="/publications">Publications</a>
                    </li>-->
                    <!-- <li class="nav-item">
                        <a class="nav-link" href="https://odp.page.link/app" target="_blank">Online Payment</a>
                    </li> -->
                    <!--<li class="nav-item">
                        <a class="nav-link " href="https://odp.page.link/app" target="_blank">Login / Payment</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                            href="https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Frli%3Dy7f7r5kwonr0%26rld%3D1&flowEntry=AddSession&flowName=GlifWebSignIn&hd=idealinstitute.edu.in&sacu=1&service=mail&dsh=S-216056736%3A1774702078384927"
                            target="_blank"> WEBMAIL</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/contact-us">Contact Us</a>
                    </li>-->
                </ul>
            </div>
        </div>
    </nav>
</div>

<!-- <div id="header">
    <div class="container">
        <div class="row d-flex align-items-center " style="padding-bottom: 0.25rem; margin-right: -4.5rem;">
            <div class="col-12 col-lg-12">
                <ul class="nav justify-content-end">
                    <li class="nav-item ">
                        <a class="nav-link mb-2"><i class="fa-solid fa-phone"></i> Helpline
                            No. - 9717594526</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"><i class="fa-solid fa-envelope"></i> ideal_institute2@rediffmail.com</a>
                    </li>
                    <li class="nav-item apply">
                        <a class="nav-link"
                            href="https://data.odpay.in/odforms1/form/GGSIPUAdmissionForm/formperma/kVJo-R_i2dCNDXxF-09oYNX3zSTOZDB5eBAze098GM8"
                            target="_blank">Enquire Now</a>
                    </li>
                    <li class="nav-item apply ms-2">
                        <a class="nav-link " href="https://www.aicte.gov.in/schemes/students-development-schemes"
                            target="_blank">AICTE Scholarships</a>
                    </li>
                    <li class="nav-item apply ms-2">
                        <a class="nav-link"
                            href="https://accounts.google.com/v3/signin/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F%3Frli%3Dy7f7r5kwonr0%26rld%3D1&flowEntry=AddSession&flowName=GlifWebSignIn&hd=idealinstitute.edu.in&sacu=1&service=mail&dsh=S-216056736%3A1774702078384927"
                            target="_blank">Webmail</a>
                    </li>
                    <li class="nav-item apply ms-2">
                        <a class="nav-link " href="https://odp.page.link/app" target="_blank">Pay Fee Online</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div> -->